import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import "@/lib/refusals";   // red refusals stay until tapped; yellow warnings until tapped or the next action

// sonner lays toasts out full width below 600 px; at the top they sat over the logo and the menu (30 Oct, his call:
// on phones the message goes to the bottom). PC and tablet keep it top-right.
const PHONE = "(max-width: 600px)";

export const AppToaster = () => {
  const [phone, setPhone] = useState(() => window.matchMedia(PHONE).matches);
  useEffect(() => {
    const mq = window.matchMedia(PHONE);
    const on = (e) => setPhone(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  // top-right sits below the 64 px header so it never covers Logout or the Floor View button
  return <Toaster position={phone ? "bottom-center" : "top-right"} offset={phone ? undefined : { top: 76, right: 16 }} />;
};
